import { useTranslation, Trans } from "next-i18next";
import {
    ApplicationPerformanceSolution,
    ApplicationProgrammingSolution
} from "../../components/v2/icons";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import Link from "next/link";
import PlatformFeaturesOverview from "../../components/v2/platform-features-overview";
import CallToActionDocsLink from "../../components/v2/blog/call-to-action-docs-link";
import '../../styles/scss/_blog-section-k8s-monitoring.module.scss';

export default function EndpointMonitoring() {
    const { t } = useTranslation("common");
    const featuresData = t("solutions.endpoint-monitoring.features.detailedFeatures", { returnObjects: true }) as any[];
    const features = Array.isArray(featuresData) ? featuresData : [];
    const resourcesData = t("solutions.endpoint-monitoring.resources.items", { returnObjects: true }) as any[];
    const resource = Array.isArray(resourcesData) ? resourcesData : [];
    const overviewData = t("solutions.endpoint-monitoring.overview", { returnObjects: true }) as any;
    const platformFeaturesConfig = {
        heading: overviewData?.heading,
        description: overviewData?.description,
        worksWellWithTag: overviewData?.worksWellWithTag,
        platforms: [
            {
                title: overviewData?.platforms?.[0]?.title,
                link: "https://docs.middleware.io/data-ingestion-apis/opentelemetry-metrics",
                Icon: ApplicationProgrammingSolution,
            },
            {
                title: overviewData?.platforms?.[1]?.title,
                link: "https://docs.middleware.io/apm-configuration/apm_overview",
                Icon: ApplicationPerformanceSolution,
            },
        ],
        cta: {
            text: overviewData?.cta?.text,
            link: "https://docs.middleware.io/apm-configuration/endpoints-observability",
        },
    };

    return (
        <>

            <ProductHeroSection title={<h1><span> {t("solutions.endpoint-monitoring.hero.titlePrefix")} </span> {t("solutions.endpoint-monitoring.hero.titleSuffix")} </h1>}
                description={t("solutions.endpoint-monitoring.hero.description")}
                img={"/images/solutions/endpoint-monitoring.webp"} imgMobile={"/images/solutions/endpoint-monitoring-mobile.webp"} imgAlt={t("solutions.endpoint-monitoring.hero.imageAlt")} preloadImg
                hasActions={false} tips={t("product.hero.tips")} hasActionsDemo={true} hasActionsDocsLink="https://docs.middleware.io/apm-configuration/endpoints-observability" />

            <PlatformFeaturesOverview data={platformFeaturesConfig} className="endpoint-monitoring-page" />

            <FeaturesMonitoring productFeatures={features}
                title={<h2><Trans i18nKey="solutions.endpoint-monitoring.features.title" components={{ highlight: <span className={"text-gradient"} /> }} /></h2>} tourId={""} className="endpoint-product" isTryOut />


            <CallToActionDocsLink
                title={t("solutions.endpoint-monitoring.ctaTitle")}
                docsLink="https://docs.middleware.io/apm-configuration/endpoints-observability"
            />

            <div className="blog-section-k8s-monitoring-resources">
                <div className="container all-blogs-v2">
                    <h2>{t("solutions.endpoint-monitoring.resources.title")}</h2>
                    <div className="d-flex">
                        {resource.map((item, index) => (
                            <div className="inner-block" key={index}>
                                <Link href={item.link} itemProp="url">
                                    <div className="image-wrapper">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                        />
                                    </div>
                                </Link>

                                <div>
                                    <Link href={`/blog/category/${item.category}`}>
                                        <div className="category">
                                            {item.categoryLabel}
                                        </div>
                                    </Link>

                                    <div>
                                        <Link href={item.link} itemProp="url">
                                            <h4>{item.title}</h4>
                                        </Link>

                                        <div className="date-time">
                                            {item.date}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

        </>
    )
}